import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Spinner, Tooltip } from "reactstrap";

const ItemContentHeader = ({ content }) => {
  return (
    <>
      <div className="d-flex align-items-center gap-2">
        {content?.Logo_Empresa_Origem ? (
          <img
            style={{ width: 24, height: 24 }}
            src={content?.Logo_Empresa_Origem}
            className="object-fit-contain rounded-circle"
          />
        ) : (
          <div
            className="object-fit-contain rounded-circle"
            style={{ width: 24, height: 24, background: "#f5f5f5" }}
          ></div>
        )}
        <span className="name">{content?.Nome_Empresa_Origem}</span>
        <i class="fas fa-external-link-alt external-link"></i>
      </div>
      {content?.Nome_Empresa_Transportadora && (
        <>
            <div className="p-0 d-flex m-0 align-content-center">
                {" "}
                <i class="icon-arrow fas fa-arrow-right"></i>{" "}
            </div>
            <div className="d-flex align-items-center gap-2">
                {content?.Logo_Empresa_Transportadora ? (
                <img
                    style={{ width: 24, height: 24 }}
                    src={content?.Logo_Empresa_Transportadora}
                    className="object-fit-contain rounded-circle"
                />
                ) : (
                <div
                    className="object-fit-contain rounded-circle"
                    style={{ width: 24, height: 24, background: "#f5f5f5" }}
                ></div>
                )}
                <span className="name">{content?.Nome_Empresa_Transportadora}</span>
                <i class="fas fa-external-link-alt external-link"></i>
            </div>
        </>
      )}
      {content?.Nome_Empresa_Destino && (
        <>
            <div className="p-0 d-flex m-0 align-content-center">
                {" "}
                <i class="icon-arrow fas fa-arrow-right"></i>{" "}
            </div>
            <div className="d-flex align-items-center gap-2">
                {content?.Logo_Empresa_Destino ? (
                <img
                    style={{ width: 24, height: 24 }}
                    src={content?.Logo_Empresa_Destino}
                    className="object-fit-contain rounded-circle"
                />
                ) : (
                <div
                    className="object-fit-contain rounded-circle"
                    style={{ width: 24, height: 24, background: "#f5f5f5" }}
                ></div>
                )}
                <span className="name">{content?.Nome_Empresa_Destino}</span>
                <i class="fas fa-external-link-alt external-link"></i>
            </div>
        </>
      )}      
    </>
  );
};

export const ContainerBoxItem = ({ contents, menu, callbackButton = () => {}, isLoadingLoadMore, disabledLoadMore, isFiltered = false }) => {
    const [ itemMenu ] = menu.filter((i) => i.ID_Objeto === contents[0]?.ID_Objeto)

    if(!isFiltered){
      disabledLoadMore = contents.length <= 3 ? true : false
      contents = contents.slice(0, 3)
    }
    
    if (!itemMenu) return
    const subtitle = itemMenu["Descricao_Objeto"];
    const iconSubtitle = itemMenu["Icone_Objeto"];

    const RenderItem = ({item}) => {
      switch (item.Sigla_Objeto) {
        case "TRA":
          return <ContentBoxTransations content={item} />
        case "MSG":
          return <ContentBoxMessages content={item} />
        default: 
          return <ContentBox content={item} />
      }
    }

    return (
      <>
        <div className="col p-0 rightbar mt-4 mb-4">
          <div className=" subtitle-item-container d-flex align-items-center gap-2">
            {iconSubtitle && <i className={`${iconSubtitle} text-color-azul1 font-size-22`}/>}
            <span
              key={"subtitle"}
              className="text-color-azul1 font-size-20 font-w-600"
            >
              {subtitle}
            </span>
          </div>
          {contents.map((item, key) => (
          <div key={key}>
            <RenderItem item={item} />
          </div>
          ))}
          {!disabledLoadMore && (
            <button disabled={isLoadingLoadMore} type="button" key={contents[0]?.ID_Objeto} id={contents[0]?.ID_Objeto} onClick={() => callbackButton(contents[0]?.ID_Objeto)} className="more-see-link">
                {isLoadingLoadMore 
                    ? <Spinner color="primary" size="sm" />
                    : "Ver mais"
                }
            </button>
          )}
        </div>
      </>
    );
};

export const ContentBox = ({ content }) => {
  const navigate = useNavigate();
  return (
    <div className={`item-container ${content?.Flag_Visualizacao === 'S' ? 'visited' : ''}`}>
      <div className="d-flex align-items-center justify-content-between item-content-header">
        <div className="d-flex align-items-center gap-3 flex-row">
          <ItemContentHeader content={content} />
        </div>
        <div className="d-flex">
          <button onClick={() => navigate(`/${content.Codigo_Transacao}?ID_Arquivo=${content.ID_Arquivo}`, { replace: true })} type="button" className="p-0 m-0 border-0 bg-transparent">
            <i class="text-color-cinza4 font-size-24 fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
      <hr />
      <div onClick={() => navigate(`/${content.Codigo_Transacao}?ID_Arquivo=${content.ID_Arquivo}`, { replace: true })}  className="d-flex align-items-center cursor-pointer justify-content-between item-content-body">
        <div className="d-flex gap-2">
          <div className="item-badge-info">
            <i class={content?.Icone_Documento}></i>
            <span>{content?.Numero_Documento}</span>
          </div>
          <div className="item-badge-info">
            <i class="fas fa-calendar-alt"></i>
            <span>{content?.Data_Hora}</span>
          </div>
          <div className="item-badge-info">
            <i class="fas fa-dollar-sign"></i>
            <span>{content?.Valor_Documento}</span>
          </div>
        </div>
        <div className="d-flex align-items-center container-status gap-2">
          {content?.Tipo_Frete && <span className="flag">{content?.Tipo_Frete}</span>}
          {content?.Icones_Status && typeof JSON.parse(content?.Icones_Status) === "object" && (
            <>
              {JSON.parse(content?.Icones_Status).map((item, key) => (
                <i key={key} class={item.icone} data-bs-toggle="tooltip" data-bs-placement="bottom" title={item.tooltip}></i>
              ))}
            </>
          ) }
          
        </div>
      </div>

      <div onClick={() => navigate(`/${content.Codigo_Transacao}?ID_Arquivo=${content.ID_Arquivo}`, { replace: true })} className="item-content-footer cursor-pointer d-flex align-items-center gap-4">
        {content?.Local_Entrega &&
            <div className="d-flex align-items-center gap-2">
            <div>
                {" "}
                <i class="fas fa-map-marker-alt"></i>{" "}
            </div>
            <span>Local de Entrega:</span>
            <span className="info-footer">{content?.Local_Entrega}</span>
            </div>
        }
        {content?.Data_Hora_Agendamento && 
            <div className="d-flex align-items-center gap-2">
            <div>
                {" "}
                <i class="fas fa-calendar-alt"></i>
            </div>
            <span>Data da Entrega:</span>
            <span className="info-footer">{content?.Data_Hora_Agendamento}</span>
            </div>
        }        
        {content?.Qtde_NFs_Agendadas && 
            <div className="d-flex align-items-center gap-2">
            <div>
                {" "}
                <i class="fas fa-receipt"></i>
            </div>
            <span>Qtde. de NF:</span>
            <span className="info-footer">{content?.Qtde_NFs_Agendadas}</span>
            </div>
        }
        {content?.Volumes_Agendados && 
            <div className="d-flex align-items-center gap-2">
            <div>
                {" "}
                <i class="fas fa-cubes"></i>
            </div>
            <span>Volumes:</span>
            <span className="info-footer">{content?.Volumes_Agendados}</span>
            </div>
        }
      </div>
    </div>
  );
};

export const ContentBoxMessages = ({ content }) => {
  const navigate = useNavigate();
  return (
    <div className="item-container container-message">
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center gap-3">
          <div className="d-flex align-items-center gap-3">
            <img className="logo-user" src={content.Imagem_Usuario} />
            <span className="name-user">{content.Nome_Usuario}</span>
          </div>
          <span className="date-message">Sexta 11:02</span>
        </div>
        <div className="d-flex">
          <button onClick={() => navigate(`/${content.Codigo_Transacao}?ID_Mensagem=${content.ID_Mensagem}`, { replace: true })} type="button" className="p-0 m-0 border-0 bg-transparent">
            <i class="text-color-cinza4 font-size-24 fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
      <hr />
      <div onClick={() => navigate(`/${content.Codigo_Transacao}?ID_Mensagem=${content.ID_Mensagem}`, { replace: true })} className="d-flex cursor-pointer align-items-center justify-content-between mb-2">
        <div className="d-flex gap-2 align-items-center">
          <span className="label-info-message">Parceiro:</span>
          <span className="info-message">{content.Empresa_Usuario}</span>
        </div>
        <div className="d-flex align-items-center gap-2">
          <span className="label-info-message">Documento:</span>
          <i class="fas fa-receipt"></i>
          <span className="info-message">{content.Numero_Documento}</span>
        </div>
      </div>
      <div onClick={() => navigate(`/${content.Codigo_Transacao}?ID_Mensagem=${content.ID_Mensagem}`, { replace: true })} className="d-flex cursor-pointer align-items-start gap-3">
        <span className="label-info-message">Mensagem:</span>
        <div className="info-message" dangerouslySetInnerHTML={{__html: content.Conteudo_Mensagem}}></div>
      </div>
    </div>
  );
};

export const ContentBoxTransations = ({ content }) => {
  const [Ttop, setTtop] = useState(false);
  return (
    <div className="item-container container-transation">
        <Link to={"/"+content.Codigo_Transacao}>
            <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center gap-3">
                    {content?.Imagem_Usuario
                        ? <img className="logo-user" src={content.Imagem_Usuario} />
                        : <div className="logo-user"></div>
                    }          
                {content?.Nome_Transacao && <span className="name-user">{content.Nome_Transacao}</span>}
                { content?.Codigo_Transacao && <span className="code-transation d-flex align-items-center gap-2">
                        Código: {content.Codigo_Transacao}
                        <i id={`TooltipTop-${content.Codigo_Transacao.trim()}`} class="fas fa-info-circle"></i>
                        <Tooltip
                          placement="top"
                          className="tooltip-info-search"
                          isOpen={Ttop}
                          target={`TooltipTop-${content.Codigo_Transacao.trim()}`}
                          toggle={() => {
                            setTtop(!Ttop);
                          }}
                        >
                          {content.Nome_Transacao}
                        </Tooltip>
                    </span> }
                </div>
            </div>
            {content?.Texto_Info && 
            <>
                <hr />
                <div className="d-flex align-items-center gap-3">
                    <span className="info-message">{content?.Texto_Info.substring(0, 330)}{(content?.Texto_Info.length > 330 ? "..." : "")}</span>
                </div>
            </> 
            }
            {!!content?.Bread_Crumb && 
            <>
                <div className="mt-2">
                  <span className="info-breadcrumb d-flex align-items-center gap-2">
                  {JSON?.parse(content?.Bread_Crumb)?.map((item, key) => (
                    <>
                      <small className="text-gray-secundary font-size-12" key={key}>{item.chave}</small>
                      {JSON?.parse(content?.Bread_Crumb)?.length - 1 !== key && <i class="fas fa-angle-right text-gray-secundary font-size-12"></i>}
                    </>
                  ))}
                  </span>
                </div>
            </> 
            }
        </Link>
    </div>
  );
};
